import React, { useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IStatsRow } from "components/dashboard/dataset-window/models/interfaces";
import { Button } from "primereact/button";
import { T } from "services/lang/LanguageService";

const Stats = ({ statsArr }: { statsArr: Array<IStatsRow> }) => {
  const dt = useRef<DataTable>(null);
  const maxDatasetPerPage = 10;

  const exportCSV = () => {
    dt.current?.exportCSV({ selectionOnly: false });
  };

  return (
    <div className="flex flex-column gap-2">
      <Button
        type="button"
        icon="pi pi-file"
        onClick={exportCSV}
        className="ml-auto p-button-sm"
        data-pr-tooltip="CSV"
        label="CSV"
      />
      <DataTable
        ref={dt}
        value={statsArr}
        paginator={statsArr?.length > maxDatasetPerPage}
        responsiveLayout="scroll"
        size="small"
        currentPageReportTemplate={`${T("word.showing")} {first} to {last} of {totalRecords}`}
        rows={maxDatasetPerPage}
        showGridlines
      >
        <Column field="title" header={T("word.title")} sortable />
        <Column field="unit" header={T("word.unit")} sortable style={{ width: 0 }} />
        <Column
          field="pointCount"
          header={T("action.count")}
          sortable
          style={{ width: 0 }}
          headerTooltip={T("label.number-of-data-points")}
        />
        <Column field="sum" header={T("word.sum")} sortable style={{ width: 0 }} />
        <Column
          field="min"
          header="Min"
          sortable
          style={{ width: 0 }}
          body={data => (data.min ? data.min : "-")}
        />
        <Column
          field="max"
          header="Max"
          sortable
          style={{ width: 0 }}
          body={data => (data.max ? data.max : "-")}
        />
        <Column
          field="delta"
          header="Delta"
          sortable
          style={{ width: 0 }}
          body={data => (data.delta ? data.delta : "-")}
          headerTooltip={T("label.difference-between-max-and-min")}
        />
        <Column
          field="mean"
          header={T("word.mean")}
          sortable
          style={{ width: 0 }}
          body={data => (data.mean ? data.mean : "-")}
        />
        <Column
          field="std"
          header="Std"
          sortable
          style={{ width: 0 }}
          body={data => (data.std ? data.std : "-")}
          headerTooltip={T("label.standard-deviation")}
        />
      </DataTable>
    </div>
  );
};

export default Stats;
